import { TimetablesDocument, useTimetableExistsQuery, useTimetablesQuery, } from 'api/generated';
import { getBaseOptions } from 'api/wrappers';
import { getApiStringFromDate, getDateFromApiString } from 'utils/date';
export const useTimetablesQueryApi = (variables, options) => {
    const { data, ...rest } = useTimetablesQuery(getBaseOptions(variables, options));
    const timetables = (data?.timetables ?? [])
        .slice()
        .sort((a, b) => (a.startDate > b.startDate ? 1 : -1))
        .map((timetable) => {
        return {
            ...timetable,
            endDate: getDateFromApiString(timetable.endDate, 'endOfDay'),
            startDate: getDateFromApiString(timetable.startDate),
        };
    });
    return { ...rest, data: timetables };
};
export const useTimetableExistsQueryApi = () => {
    const { data, ...rest } = useTimetableExistsQuery();
    return { data: data?.timetableExists ?? false, ...rest };
};
export const getCreateTimetableMutationOptions = (timetable) => ({
    refetchQueries: [TimetablesDocument],
    variables: {
        input: {
            ...timetable,
            endDate: getApiStringFromDate(timetable.endDate),
            startDate: getApiStringFromDate(timetable.startDate),
        },
    },
});
export const getUpdateTimetableMutationOptions = (timetable) => {
    return {
        variables: {
            input: {
                ...timetable,
                endDate: getApiStringFromDate(timetable.endDate),
                startDate: getApiStringFromDate(timetable.startDate),
            },
        },
    };
};
export const getDeleteTimetableMutationOptions = (id) => ({
    refetchQueries: [TimetablesDocument],
    variables: {
        id,
    },
});
export { useCreateTimetableMutation, useDeleteTimetableMutation, useUpdateTimetableMutation, } from 'api/generated';
